import {
  faro,
  getWebInstrumentations,
  initializeFaro,
  type Faro,
} from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import type { NavigationHookAfter } from 'vue-router'
import { name, version } from '../package.json'

function getSamplingRate () {
  const parsedSamplingRate = parseFloat(
    import.meta.env.VITE_FARO_SAMPLING_RATE ?? '1'
  )

  return Number.isFinite(parsedSamplingRate) &&
    parsedSamplingRate >= 0 &&
    parsedSamplingRate <= 1
    ? parsedSamplingRate
    : 1
}

export function initFaro (): Faro | null {
  const url = import.meta.env.VITE_FARO_COLLECTOR_URL

  if (url == null || url === '') return null

  return initializeFaro({
    url,
    app: {
      name,
      version: import.meta.env.VITE_COMMIT_REF ?? version,
      environment: import.meta.env.VITE_CONTEXT ?? import.meta.env.MODE,
      namespace: 'ropescore',
    },
    sessionTracking: {
      samplingRate: getSamplingRate(),
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation({
        instrumentationOptions: {
          // Link API requests to the API's own traces. Only the hosted API,
          // whose CORS policy allows `traceparent` and `tracestate`: venue
          // servers (*.local.ropescore.com) may run older versions that would
          // fail the preflight.
          propagateTraceHeaderCorsUrls: [
            /^https:\/\/api\.ropescore\.com\//,
            /^https:\/\/ropescore-api-224455118938\.[a-z0-9-]+\.run\.app\//,
          ],
        },
      }),
    ],
  })
}

export const setFaroView: NavigationHookAfter = (to, _from, failure) => {
  if (failure != null) return

  const viewName = to.name?.toString() ?? to.matched.at(-1)?.path ?? to.path

  faro.api.setView({ name: viewName })

  faro.api.pushEvent('vue_route_changed', {
    routeName: viewName,
    routePath: to.path,
    routeFullPath: to.fullPath,
    routeParams: JSON.stringify(to.params),
  })
}
